module.exports = __webpack_public_path__ + "static/media/dark-brick.89eaa8e2.jpg";